var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "theme-ui/jsx-runtime";
import { FormVariants } from "../../index";
import { Box, Checkbox as _Checkbox, Label } from "theme-ui";
import { FormError } from "./index";
export const Checkbox = (_a) => {
    var { id, name, label, checked, children, ref, hasError, errorMessage, labelVariant = "text.label2" } = _a, props = __rest(_a, ["id", "name", "label", "checked", "children", "ref", "hasError", "errorMessage", "labelVariant"]);
    //const [isChecked, setChecked] = useState(checked)
    return (_jsxs(Box, { children: [_jsxs(Label, { sx: {
                    alignItems: "center",
                    color: "black.1",
                    variant: labelVariant
                }, as: "label", htmlFor: id, children: [_jsx(_Checkbox, Object.assign({ id: id, name: name, checked: checked ? true : undefined }, props, { sx: { mr: 8, variant: `forms.${FormVariants.checkbox}` } })), label] }), hasError && errorMessage && (_jsx(Box, { sx: { pl: 24, ml: 8 }, children: _jsx(FormError, { children: errorMessage }) }))] }));
};
//# sourceMappingURL=Checkbox.js.map